import React, { useEffect, useState } from 'react';
import {
    Button,
    Grid,
    Typography,
    InputAdornment,
    TextField,
    Backdrop,
    Modal,
    Fade,
    Box,
    FormControl,
    FormHelperText,
    FormControlLabel,
    InputLabel,
    OutlinedInput,
    Divider,
    Radio,
    RadioGroup
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Formik } from 'formik';
import { ADD_TEAM_MEMBER, ADD_TEAM_NAME } from 'schemas/mutation';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQuery } from '@apollo/client';
import { SET_COMPANY_DATA, SET_LOADING, SET_MODAL_STATUS, SET_TOAST_OBJECT } from 'store/actions';
import * as Yup from 'yup';
import { setReload } from 'store/MyTeam/types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AnnouncementImage from 'assets/images/dashboard/announcement.svg';

function NotSubscribedForNonCreatorModal(props) {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    let companyData = customization.companyData;
    const dispatch = useDispatch();
    const { reload } = useSelector((params) => params.myteam);
    const [errorMsg, setErrorMsg] = React.useState();

    const handleClose = () => {
        setErrorMsg();
        dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24
    };

    return (
        <>
            <Box className="modal-hero">
                <img src={AnnouncementImage} alt="announcement" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    Sorry for inconvinence!
                </Typography>
                <p>
                    The subscription plan for current company admin is inactive. Contact company admin to renew subscription to continue
                    using diolog.
                </p>
            </Box>
            <Box className="modal-footer pt-0">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button variant="outlined" className="alternate-reversed w-full" onClick={handleClose}>
                            Close
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default NotSubscribedForNonCreatorModal;
